var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classModifiers},[_c('label',{attrs:{"for":_vm.name}},[_c('div',{staticClass:"toggle-v3__label"},[_vm._t("label")],2),_c('input',{attrs:{"type":"checkbox","name":_vm.name,"id":_vm.name},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_c('div',{staticClass:"toggle-v3__tick"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }